/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OrganizationRole = {
    type: 'Enum',
} as const;
